<template>
  <div class="main-page-container">
      <AlertFoundActiveSession />

      <PageHeader className="d-flex align-items-center" :title="$t('sideNavbarMenu.users.text')">
          <div class="page-title-right  d-flex"> 

              <b-button pill class="d-flex vp-ml-40 align-items-center  justify-content-center text-center top-users-btn" variant="primary" size="sm"
                  v-on:click="openAddUserModal" v-b-modal.add-edit-user>
                  <!-- <i class="bx bxs-user-plus font-size-18 mr-2"></i>  -->
                  {{ this.$t('common.add') }}       
              </b-button>

              <router-link to=/users/import>
                  <b-button pill class="d-flex vp-ml-24 align-items-center justify-content-center text-center top-users-btn" variant="primary" size="sm">
                      <!-- <i class="bx bx-import font-size-18 mr-2"></i>  -->
                      {{ this.$t('common.import') }}
                  </b-button>
              </router-link>
          </div>
      </PageHeader>

      <!-- start::Acl error modals -->
        <AclErrorModals />
      <!-- end::Acl error modals -->

      <b-modal id="exportingProgress" hide-footer hide-header size="lg" :scrollable="false">
          <ExportProgress />
      </b-modal>

       <!-- add document  -->
      <b-modal id="addDocumentModal" class="popover-modal" hide-header hide-footer no-close-on-esc :scrollable='true' ref="addDocumentModal">
          <AddDocument @changeUserStatusOrDeleted="refreshUsersGrid"/>
      </b-modal>
      
      <!-- vaccine details  -->
      <b-modal id="vaccineDetailsModal" class="popover-modal" hide-header hide-footer no-close-on-esc :scrollable='true' ref="vaccineDetailsModal">
          <VaccineDetails @getActionStatusOrDeleted="getAction"/>
      </b-modal>


      <!--confirm vaccine details  -->
      <b-modal id="deleteActionModal" size="lg" class="popover-modal" hide-header hide-footer no-close-on-esc :scrollable='true' ref="deleteActionModal">
          <DeleteAction  @changeUserStatusOrDeleted="refreshUsersGrid"/>
      </b-modal>

      <!--RFID Enrollment  -->
      <b-modal id="rfidEnrollmentModal" size="lg" class="popover-modal" hide-header hide-footer no-close-on-esc :scrollable='true' ref="rfidEnrollmentModal">
          <RFIDEnrollmentModal  @changeUserPassportStatus="setUserStatus"/>
      </b-modal>

      <!-- :scrollable='getCompliances.length>0?true:false'  -->
      <!-- check in user  -->
      <b-modal id="dashboardActionOne" hide-footer hide-header size="md" :scrollable="true">
          <UserCheckinAction :parentGrid="'users'"/>
      </b-modal>
      <!-- change user type -->
      <b-modal id="changeUserType" hide-footer hide-header size="lg">
          <ChangeUserType @changeUserStatusOrDeleted="refreshUsersGrid"/>
      </b-modal>
      <!-- update user  -->
      <b-modal :id="'add-edit-user' + (isHide ? '-hide' : '')" size="lg" class="popover-modal" hide-header hide-footer no-close-on-esc :scrollable='true' ref="add-edit-user">
          <UserForm :data="$store.state.modal.data" :cropImageData="cropImageData" :allLabels="allLabels"  @changeUserStatusOrDeleted="refreshUsersGrid" @storeBackupUserData="fetchBackupData"/>
      </b-modal>

      <!-- invite uesr -->
      <b-modal id="passportActionFormModal" :scrollable="true" hide-footer hide-header size="lg">
          <PassportAction @changeUserStatusOrDeleted="refreshUsersGrid" @changeUsersPassportStatus="setUsersStatus"/>
      </b-modal>
      <!-- invite uesr -->

      <!-- invoke uesr -->
      <b-modal id="passportActionConfirmModal" :scrollable="true" hide-footer hide-header size="lg">
          <PassportAction @changeUserStatusOrDeleted="refreshUsersGrid" @changeUsersPassportStatus="setUsersStatus"/>
      </b-modal>
      <!-- invoke uesr -->

      <!-- add permissions user -->
      <b-modal id="addUserPermissionsModal" :scrollable="true" hide-footer hide-header size="lg">
          <addUserPermissionsModal @changeUserStatusOrDeleted="refreshUsersGrid"/>
      </b-modal>
      <!-- add permissions user -->

      <b-modal id="userStatusToggleConfirmModal" :scrollable="true" hide-footer hide-header size="lg">
          <UserStatusToggle @changeUserStatusOrDeleted="refreshUsersGrid"/>
      </b-modal>

      <b-modal id="change-user-type-massaction" hide-footer hide-header  size="lg">
        <ChangeUserTypeMassaction />
      </b-modal>

      <b-modal id="change-user-type-massaction-success-message" no-close-on-esc 
          no-close-on-backdrop hide-footer hide-header :scrollable="true" size="lg">
        <changeUserTypeSuccessMessage @refreshGrid="resetGrid" />
      </b-modal>
      
      <b-modal id="revoke-from-dashboard" hide-footer hide-header size="lg">
          <RevokeFromDashboard />
      </b-modal>
      <b-modal id="revoke-confirm-modal" hide-footer hide-header no-close-on-esc no-close-on-backdrop>
          <RevokeFromDashboardConfirmation />
      </b-modal>

      <b-modal id="add-label" hide-footer hide-header size="lg" no-close-on-esc no-close-on-backdrop>
        <AddLabel :allLabels="allLabels" @changeUserStatusOrDeleted="resetGrid" />
      </b-modal>

      <b-modal id="permissions" hide-footer scrollable hide-header size="lg">
          <Permissions :selectedUsers="selectedUsers" @resourceUpdated="refreshUsersGrid"/>
      </b-modal>


      <!-- delete user action  -->
      <b-modal id="confirmVaccineModal" class="popover-modal" hide-header hide-footer no-close-on-esc :scrollable='true' ref="confirmVaccineModal">
          <confirmVaccineAction :action="vaccineAction"  @changeUserStatusOrDeleted="refreshUsersGrid"/>
      </b-modal>

      <Modal :title="$t('preRegisteration.viewListSettings')" :modalID="Object.keys(this.$route.params).length > 0 ? this.$route.params.name : 'users'">
          <template>
              <ColumnsSwitcher 
              :vaccineColumn='vaccinePCRColumnAppearance' 
              grid='users' 
              :hasDocuments="documentsTypesAraa" :tableHeaders="getTableHeaders" :url="getUsersURL"
              :modalID="Object.keys(this.$route.params).length > 0 ?this.$route.params.name : 'users'"
              :fetchTableHeaders="fetchTableHeaders" />
          </template>
      </Modal>

      <CropperImage :message="cropMessage" :errorMessage="cropErrorMessage" :area="cropArea" :type="cropType"
      :minHeigh="300" :minWidth="250" :ratio=1 :maxSize="3145728"
      @croppedImageEvent=showEditUserModal  @closeCroppedImageModal=showEditUserModal  />

      <!-- grid -->
      <section  class="users-white-bg-sec users-list-table " :class="{'hide-loader': hideLoader}" style="background-color:white">

          <div class="main-grid-buttons">
              <div class="grid-buttons">
                  <div class="grid-buttons-contanier">
                      <button @click="showCurrentTab('active')" class="active-users-view cursor-pointer" :class="{ 'diabledBtnTab' : !activeUsersTab }">{{ $t("users.form.activeUsers") }}</button>
                      <button @click="showCurrentTab('archive')" class="archived-users-view cursor-pointer" :class="{ 'diabledBtnTab' : !archivedUsersTab}">{{ $t("users.form.archivedUsers") }}</button>
                  </div>
              </div>
              <div class="seperator-main-grid-buttons"></div>
          </div>

          <DxDataGrid v-show="activeUsersTab" id="activeUsersListGridContainer" :data-source="dataStore" :ref="dataGridRefName" :remote-operations="true"
          :columns="gridColumns"
          :rtl-enabled="rtlEnabled"
          :showBorders="false" :columnAutoWidth="true" :allowColumnReordering="true" :allowColumnResizing="true"
          :rowAlternationEnabled="false" :showColumnLines="true" :showRowLines="true" :cacneEnabled="false"
          :no-data-text="gridEmptyMessage" @content-ready="contentReady($event)"
          @selection-changed="onSelectionChanged"
          @select-all-value-changed="handleSelectAllValueChanged"
          @editor-preparing="onEditorPreparing($event)" :class="{ 'no-content': dataStore.length <= 0 && gridLoaded, 'usersGridHeightWithAlert': getActiveSessionsCount, 'usersGridHeight': !getActiveSessionsCount } "
          @data-error-occurred="onDataErrorOccurred($event)"
          >

          <DxStateStoring :enabled="true" type="custom"  :customSave="customSave" :customLoad="customLoad"/>
          <DxScrolling mode="standard" :scroll-by-content="rtlEnabled" :use-native="!rtlEnabled" />
          <DxPaging :page-size="50" />
          <DxPager :visible="true" :allowed-page-sizes="[ 5, 10, 25, 50, 100]" :display-mode="'full'"
          :show-page-size-selector="true" :show-info="true" :show-navigation-buttons="true" 
          :infoText="rtlEnabled ?  'صفحة {0} من {1} ({2} إجمالي العناصر)' : ''"

          />

          <DxFilterRow :visible="true" />

          <DxHeaderFilter :visible="true" />

          <DxColumnChooser :enabled="true" mode="select" :title="$t('common.grid.columnChooser')" />

          <DxExport :enabled="true" :allow-export-selected-data="false" />

          <DxSelection mode="multiple" :select-all-mode="'page'"/>

          <DxToolbar v-if="isFoundSelection" :key="isRevokeFromDashboard || rfidEnrollment || isInviteToDashboard || hasPermissionAction || isMassActionsAvailable">
              <DxItem template="clearAllTemplate" location="before" />
              <DxItem v-if="isFoundSelection" template="usersSelectionCounterTemplate" location="before" />
              <DxItem v-if="!isDefaultUserSelected" template="changeUserTypeTemplate" location="before" />
              <!-- <DxItem template="changeUsersRoleTemplate" location="before" /> -->
              <DxItem v-if="rfidEnrollment" template="rfidEnrollment" location="before" />
              <DxItem v-if="isInviteToDashboard" template="inviteToDashboardTemplate" location="before" />
              <DxItem v-if="hasPermissionAction" template="permissionsTemplate" location="before" />
              <DxItem v-if="isRevokeFromDashboard" template="revokeFromDashboardTemplate" location="before" />
              <!-- <DxItem template="allowUsersTemplate" location="before" /> -->
              <!-- <DxItem template="denyUsersTemplate" location="before" /> -->
              <!-- <DxItem template="archiveUsersTemplate" location="before" /> -->
              <!-- <DxItem template="deleteUsersTemplate" location="before" /> -->
              <DxItem v-if="isAddLabel" template="addLabelTemplate" location="before" />
              <DxItem template="signInMassActionTemplate" location="before" />
              <!-- <DxItem v-if="isMassActionsAvailable" template="massActionsNoteTemplate" location="before" /> -->
          </DxToolbar>

          <DxToolbar v-else>
              <DxItem location="before" template="columnButtonTemplate" />
              <DxItem location="before" template="exportButtonTemplate" />
              <DxItem location="before" template="clearAllTemplate"/>
          </DxToolbar>

          <template #labels-template="{data}">
            <div class="rating-label-container" v-if="data.value && !data.data.is_default_user" style="position: relative">
              <span class="rating-label"
              :style="{ marginInlineStart: data.value > 9 ? '24%' : '36%'}">{{ Number(data.value) }}</span>
            </div>
            <span v-else>-</span>
          </template>

          <template #stars-template="{data}">
            <div v-if="data.value && !data.data.is_default_user" style="position: relative">
              <svg width="24" height="24" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 25.4465L6.993 29.8547C6.13663 30.3242 5.13656 29.5678 5.29908 28.5701L6.83048 19.2321L0.354854 12.6197C-0.338965 11.9155 0.0423195 10.683 0.998661 10.5395L9.9495 9.17663L13.9561 0.679814C14.3812 -0.226605 15.6188 -0.226605 16.0501 0.679814L20.0505 9.17663L29.0013 10.5395C29.9577 10.683 30.3389 11.9155 29.6452 12.6197L23.1695 19.2321L24.701 28.5701C24.8634 29.5678 23.8634 30.3308 23.007 29.8547L15 25.4465Z" fill="#103F5E"/>
              </svg>
              <span class="rating-star"
              :style="{ marginInlineStart: data.value > 9 ? '-9.5%' : '-8%'}">{{ Number(data.value) }}</span>
            </div>
            <span v-else>-</span>
          </template>

          <template #smileys-template="{data}">
            <div v-if="data.value && !data.data.is_default_user" class="d-flex align-items-center" style="gap: 8px">
              <div v-if="data.value && !data.data.is_default_user" class="grid-smiley-container">
                <div class="d-flex align-items-center">
                  <span class="svg-div" v-html="getData(data).smileySvg"></span>
                  
                </div>
              </div>
              <p class="smiley-text"
                  :style="{color: getData(data).smileyColor}">{{ getData(data).smileyText }}</p>
            </div>
            <span v-else>-</span>
          </template>

          <template #checkboxes-template="{data}">
            <span v-if="data.value && !data.data.is_default_user">{{ getCheckboxVal(data.value) }}</span>
            <span v-else>-</span>
          </template>

          <template #date-template="{data}">
            <span v-if="data.value && !data.data.is_default_user">{{ data.value }}</span>
            <span v-else>-</span>
          </template>

          <template #toggle-template="{data}">
            <span v-if="(data.value == 0 || data.value == 1) && !data.data.is_default_user">{{ +data.value ? "Yes" : "No" }}</span>
            <span v-else>-</span>
          </template>
          
          <template #customField-template="{data}">
            <span v-if="data.value && !data.data.is_default_user">{{ data.value }}</span>
            <span v-else>-</span>
          </template>
          
          <template #rfid-template="{data}">
              <!-- {{ data.data.RFID }} -->
              {{ data.data.RFID ? rfidFormatter(data.data.RFID) : '-'}}
          </template>

          <template #image-cell="{ data }">
              <div class="images dash-img clearfix" style="margin: auto;">
                <ImageCell v-if="!data.data.Image" :name="data.data.FirstName ? data.data.FirstName.charAt(0) : '' "/>
                  
                <img v-if="data.data.Image" v-viewer class="img-fluid rounded-circle"
                  style="cursor: pointer" :src="data.data.Image+'?cacheBust='+Math.random()" crossorigin="anonymous"/>
              </div>
            <!-- to rerender the image cell after calling the datasource-->
          </template>

          <template #status-cell="{ data }">
              <div class="my-2 d-flex align-items-center p-1">
                  <StatusCell :status="data.data.Status" :data="data.data.Data" />
              </div>
          </template>

          <template #vaccine-document-cell="{ data }">
              <span class="text-capitalize" @click=" data.data.vaccine_document != 'Unchecked' && setUserData(data.data)"
              v-b-modal="data.data.vaccine_document != 'Unchecked' &&'vaccineDetailsModal'"
              >{{data.data.vaccine_document}}</span>
          </template>

          <template #usersSelectionCounterTemplate>
              <p class="toolbar-users-counter">{{ usersSelectedCounter }} {{usersSelectedCounter == 1 ? $t('users.form.userSelected') : $t('users.form.usersSelected') }} </p>
          </template>

          <template #changeUserTypeTemplate>
              <button class="toolbar-action-buttons toolbar-main" @click="massAction('user-type')">
                  <span class="custom-text">{{ $t('common.change') }} {{ $t('common.userType') }}</span>
              </button>
          </template>

          <!-- <template #changeUsersRoleTemplate>
              <div class="d-flex justify-content-between">
                  <button class="toolbar-action-buttons toolbar-main">
                      <span class="custom-text">Change role</span>
                  </button>
                  <div class="v-line"></div>
              </div>
          </template> -->
          

          <template #rfidEnrollment>
              <div class="d-flex justify-content-between">
                  <button @click="massAction('rfid-enrollment')" class="toolbar-action-buttons toolbar-main">
                      <span class="custom-text">{{ $t('common.rfidEnrollment') }}</span>
                  </button>
                  <div v-if="isInviteToDashboard || isRevokeFromDashboard" class="v-line"></div>
              </div>
          </template>

          <template #inviteToDashboardTemplate>
              <button @click="massAction('invite-to-dashboard')" class="toolbar-action-buttons toolbar-main">
                  <span class="custom-text">{{ $t('users.form.inviteToDashboard') }}</span>
              </button>
          </template>

          <template #revokeFromDashboardTemplate>
              <div class="d-flex justify-content-between">
                  <button @click="massAction('revoke-from-dashboard')" class="toolbar-action-buttons toolbar-alert">
                      <span class="custom-text">{{ $t('users.form.revokeFromDashboard') }}</span>
                  </button>
                  <!-- <div class="v-line"></div> -->
              </div>
          </template>

          <template #permissionsTemplate>
            <div class="d-flex justify-content-between">
              <button @click="massAction('permissions')" class="toolbar-action-buttons toolbar-main">
                <span class="custom-text">{{ $t('common.permissions') }}</span>
              </button>
              <!-- <div class="v-line"></div> -->
            </div>
          </template>

          <!-- <template #allowUsersTemplate>
              <button class="toolbar-action-buttons toolbar-main">
                  <span class="custom-text">Allow</span>
              </button>
          </template> -->

          <!-- <template #denyUsersTemplate>
              <div class="d-flex justify-content-between">
                  <button class="toolbar-action-buttons toolbar-alert">
                      <span class="custom-text">Deny</span>
                  </button>
                  <div class="v-line"></div>
              </div>
          </template> -->

          <!-- <template #archiveUsersTemplate>
              <button class="toolbar-action-buttons toolbar-main">
                  <span class="custom-text">Archive</span>
              </button>
          </template> -->

          <!-- <template #deleteUsersTemplate>
              <div class="d-flex justify-content-between">
                  <button class="toolbar-action-buttons toolbar-alert">
                      <span class="custom-text">Delete</span>
                  </button>
                  <div class="v-line"></div>
              </div>
          </template> -->

          <template #addLabelTemplate>
            <div class="d-flex justify-content-between">
              <div class="v-line"></div>
              <button class="toolbar-action-buttons toolbar-main" @click="massAction('add-label')">
                <span class="custom-text">{{ $t('common.add') }} {{ $t('common.label') }}</span>
              </button>
            </div>                
          </template>

          <template #signInMassActionTemplate>
            <div class="d-flex justify-content-between">
              <div class="v-line"></div>
              <button @click="$bvModal.show('signinMassaction');massAction('sign_in')" class="toolbar-action-buttons toolbar-secondary">
                  <span class="custom-text">{{ $t('common.signInOut') }}</span>
              </button>

              <b-modal id="signinMassaction" hide-footer hide-header size="md" :scrollable="false">
                <SignInMassAction :parentGrid="'userlist'" :selectedUsers="selectedUsers" />
              </b-modal>
            </div>
          </template>

          <template #massActionsNoteTemplate>
              <p class="toolbar-mass-actions-note">{{ $t('common.notes.massActionsNote') }}</p>
          </template>

          <template #exportButtonTemplate>
              <DxDropDownButton class="export-dropdown" :items="buttonData" :text="$t('common.grid.export')" @item-click="serverSideExport"/>
          </template>

          <template #columnButtonTemplate>
              <button class="custom-columns" @click="showColumnChooserPopup()">
                  <span class="custom-text">{{$t('common.grid.columns')}} </span>
                  <span class="custom-icon">            
                    <i class="dx-icon dx-icon-spindown dx-icon-right"></i>
                  </span>
              </button>
          </template>

          <template #clearAllTemplate>
              <div v-if="showClearAll" class="d-flex clear-cols  align-items-center">
                  <div v-if="!isFoundSelection" class="toolbar-custom-line"></div>
                  <Button :text="$t('common.grid.clearFilters')" @click="reset()" styling-mode="outlined" :class="{
                    'first-clear': !isFoundSelection,
                    'vp-ml-24': isFoundSelection
                  }" type="danger" class="clear-CustomColums" />
                  <div v-if="isFoundSelection" class="v-line" style="height: 75px;margin-inline-start:24px!important;margin-inline-end:0px"></div>
              </div>
          </template>

          <template #actions-cell="{ data }">
              <ActionCell :isSelected="isFoundSelection" :status="data.data.Status" :userData="data.data.Data" @changeUserStatusOrDeleted="refreshUsersGrid"/>                
          </template>

          </DxDataGrid>

          <ArchivedUsersGrid ref="archivedGridRef" v-if="!activeUsersTab" :allLabels="allLabels" @onUpdate=refreshUsersGrid />

      </section>     
      <vp-page-loader v-if="rfidEnrollmentLoader" :loaderTitle="$t('common.checkingData')"/>
      <!-- Modal -->
      <!-- <button @click="$bvModal.show('confirm-modal')">Show modal</button> -->
      <b-modal id="rfid-enrollment-confirmation-modal" scrollable size="lg" hide-footer hide-header >
          <confirmation-modal/>
      </b-modal> 
    </div>
</template>

<script>
const dataGridRefName = "dataGridActiveUsersList";
import smileysJson from "@/router/views/customFields/smileys.json";
import { default as Button } from "devextreme-vue/button";
import { mapActions, mapGetters } from "vuex";
import PageHeader from "../../../components/page-header.vue";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import { usersColumns } from "@/utils/dataSource";
import ImageCell from "@/components/sharedCells/ImageCell";
import "jspdf-autotable";
import AlertFoundActiveSession from "@/components/emergency/AlertFoundActiveSession";
import Modal from "@/components/modal/Modal";
import ColumnsSwitcher from "@/components/sharedCells/ColumnsSwitcher";
import UserForm from "@/components/users/user-form";
import StatusCell from "@/components/sharedCells/StatusCell";
import ActionCell from "@/components/users/ActionCell";
import UserCheckinAction from "@/components/sharedCells/userAction/UserCheckinAction";
import ChangeUserType from "@/components/users/ChangeUserType";
import AddDocument from "@/components/users/AddDocument";
import VaccineDetails from "@/components/users/VaccineDetails";
import confirmVaccineAction from "@/components/users/confirmVaccineAction";
import PassportAction from "@/components/users/PassportAction";
import DeleteAction from "@/components/users/DeleteAction";
import RFIDEnrollmentModal from "@/components/users/RFIDEnrollmentModal";
import UserStatusToggle from "@/components/users/UserStatusToggle";
import CustomStore from "devextreme/data/custom_store";
import store from "@/state/store";
import Api from "../../../services/Api";
import usersService from "@/services/users.js";
import ExportProgress from "@/components/grid/ExportProgress";
import CropperImage from "@/components/sharedCells/CropperImage";
import RevokeFromDashboard from "./RevokeFromDashboard.vue";
import ChangeUserTypeMassaction from "./ChangeUserTypeMassaction.vue";
import changeUserTypeSuccessMessage from "./ChangeUserTypeMassactionSuccessMessage.vue"
import AddLabel from "./AddLabel.vue";
import RevokeFromDashboardConfirmation from "./RevokeFromDashboardConfirmation.vue";
import Permissions from "./permissionsModal.vue";
import { rfidFormatterMixin } from "@/utils/mixins/rfidFormatterMixin";
import ConfirmationModal from "./rfidEnrollmentMassAction/ConfirmationModal.vue";
import ArchivedUsersGrid from "./ArchivedUsersGrid.vue";
import addUserPermissionsModal from "@/components/users/addUserPermissionsModal";
import SignInMassAction from "../dailylogUsersMassaction/MassactionIndex.vue";
import AclErrorModals from "@/router/views/dailylogUsersMassaction/modals/acl/Index.vue";

import DxDataGrid, {
// DxColumn,
DxFilterRow,
DxHeaderFilter,
DxColumnChooser,
DxExport,
DxToolbar,
DxItem,
DxStateStoring,
DxPager,
DxPaging,
DxScrolling,
DxSelection,
} from "devextreme-vue/data-grid";

function isNotEmpty(value) {
return value !== undefined && value !== null && value !== "";
}

export default {
name: "users",
title: "Users",
mixins: [rfidFormatterMixin],
components: {
  Button,
  PageHeader,
  DxDataGrid,
  // DxColumn,
  DxFilterRow,
  DxHeaderFilter,
  DxColumnChooser,
  DxExport,
  DxToolbar,
  DxItem,
  DxDropDownButton,
  ImageCell,
  DxStateStoring,
  AlertFoundActiveSession,
  DxPager,
  DxPaging,
  DxSelection,
  Modal,
  ColumnsSwitcher,
  UserForm,
  StatusCell,
  ActionCell,
  UserCheckinAction,
  ChangeUserType,
  AddDocument,
  VaccineDetails,
  PassportAction,
  UserStatusToggle,
  ExportProgress,
  DxScrolling,
  confirmVaccineAction,
  RevokeFromDashboard,
  ChangeUserTypeMassaction,
  changeUserTypeSuccessMessage,
  AddLabel,
  RevokeFromDashboardConfirmation,
  Permissions,
  CropperImage,
  ArchivedUsersGrid,
  DeleteAction,
  ConfirmationModal,
  RFIDEnrollmentModal,
  addUserPermissionsModal,
  SignInMassAction,
  AclErrorModals
},
data() {
  return {
    usersGridData : [],
    documentsTypesAraa : [],
    vaccinePCRColumnAppearance : null,
    gridEmptyMessage : this.$t('common.grid.loadingData'),
    rtlEnabled : false,
    isDefaultUserSelected: false,
    isHide: false,
    gridLoaded: false,
    allFilterHeaders: ['UserType', 'DashboardAccess', 'vaccine_document', 'VisiPointPassport'],
    title: "Users",
    hideLoader: false,
    selectedUsersIds: [],
    selectedIds: [],
    allLabels: [],
    dataGridRefName,
    isAddModal: false,
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    allowedOperations: ["contains"],
    selectedOperation: "contains", // default icon
    isServerSideExport: false,
    buttonData: ["Excel", "CSV", "PDF"],
    multipleFilters: [],
    usersColumns: usersColumns,
    userTypeHeaderFilter: [],
    isEdit: false,
    defaultStatus: ["Active"],
    filterExportObject: {},
    cropMessage:
      this.$t("common.notes.uploadImgNote"),
    cropErrorMessage:
      this.$t("common.notes.uploadImgNote"),
    cropType: this.$t("common.image"),
    cropArea: "circle",
    sortExportObject: {
      sortField: null,
      sortOrder: null,
    },
    statusFilterValue: ["Status", "contains", "Active"],
    statusHeaderFilter: [
      {
        text: "Active",
        value: "Active",
      },
      {
        text: "Denied",
        value: "Denied",
      },
    ],
    systemUserHeaderFilter: [
      // {
      //     text: "Yes",
      //     value: "Yes",
      // },
      {
        text: "No",
        value: ["DashboardAccess", "contains", "no"],
      },
      {
        text: "Pending",
        value: ["DashboardAccess", "contains", "pending"],
      },
    ],
    VisiPointPassportHeaderFilter: [
      {
        text: "Yes",
        value: "Yes",
      },
      {
        text: "Deactivated",
        value: "Deactivated",
      },
      {
        text: "No",
        value: "No",
      },
    ],
    vaccine_documentHeaderFilter: [
      {
        text: "Vaccinated",
        value: "Vaccinated",
      },
      {
        text: "Unchecked",
        value: "Unchecked",
      },
      {
        text: "Negative PCR",
        value: "Negative PCR",
      },
      {
        text: "Positive PCR",
        value: "Positive PCR",
      },
      {
        text: "Expired",
        value: "Expired",
      },
      {
        text: "Disabled",
        value: "Disabled",
      },
    ],
    toggleHeaderFilter: [
      {
        text: "Yes",
        value: 1,
      },
      {
        text: "No",
        value: 0,
      },
    ],
    vaccineDocument: false,
    vaccineAction: null,
    userParams: {
      firstName: null,
      lastName: null,
      id: null,
      email: null,
      userId: null,
      rfid: null,
      UserType: null,
    },
    sortObject: {},
    totalCount: "",
    showClearAll: false,
    isFoundSelection: false,
    usersSelectedCounter: null,
    isMassActionsAvailable: false,
    isInviteToDashboard: false,
    isRevokeFromDashboard: false,
    rfidEnrollment: false,
    rfidEnrollmentLoader: false,
    hasPermissionAction: false,
    isAddLabel: false,
    selectedUsers: [],
    addUserBackupDataModal: {},
    activeUsersTab: true,
    archivedUsersTab: false,
    cropImageData: null,
    dataStore: [],
    usersData: [],
    allCustomFields: [],
    fields: [
      {
        dataField: "Image",
        caption: this.$t("common.image"),
        cellTemplate: "image-cell",
        minWidth: 89,
        allowFiltering: false,
        allowEditing: false,
        showInColumnChooser: true,
        alignment: "center",
        cssClass: "image-index",
        allowExporting: true,
      },
      {
        dataField: "FirstName",
        caption: this.$t("common.firstName"),
        allowHeaderFiltering: false,
        minWidth: 200
      },
      {
        dataField: "LastName",
        caption: this.$t("common.lastName"),
        allowHeaderFiltering: false,
        minWidth: 200
      },
      {
        dataField: "UserType",
        caption: this.$t("common.userType"),
        allowEditing: false,
        allowFiltering: false,
        allowHeaderFiltering: true,
        headerFilterDataSource: "userTypeHeaderFilter"
      },
      {
        dataField: "DashboardAccess",
        caption: this.$t("users.grid.dashboardAccess"),
        allowFiltering: false,
        allowHeaderFiltering: true,
        allowSorting: false,
        allowEditing: false,
        calculateCellValue: this.getAccess,
        allowSearch: true,
        headerFilterDataSource: "systemUserHeaderFilter"
      },
      {
        dataField: "EmailAddress",
        caption: this.$t("common.emailAddress"),
        allowHeaderFiltering: false,
        minWidth: 200
      },
      {
        dataField: "PhoneNumber",
        caption: this.$t("common.phoneNumber"),
        allowHeaderFiltering: false,
      },
      {
        dataField: "VisiPointPassport",
        caption: this.$t("users.grid.visipointPassport"),
        allowHeaderFiltering: true,
        allowFiltering: false,
        headerFilterDataSource: "VisiPointPassportHeaderFilter"
      },
      {
        dataField: "RFID",
        caption: this.$t("common.RFID"),
        allowHeaderFiltering: false,
        minWidth: 200,
        allowSorting: false,
        cellTemplate: "rfid-template"
      },
      {
        dataField: "ID",
        caption: this.$t("common.id"),
        allowHeaderFiltering: false,
        allowEditing: false,
        minWidth: 200
      },
      {
        dataField: "vaccine_document",
        caption: this.$t("dashboard.grid.vaccineDoc"),
        allowFiltering: false,
        allowHeaderFiltering: true,
        allowSorting: false,
        allowEditing: false,
        cellTemplate: "vaccine-document-cell",
        headerFilterDataSource: "vaccine_documentHeaderFilter"
      },
      // {
      //   dataField: "Status",
      //   caption: "Status",
      //   allowEditing: false,
      //   allowFiltering: false,
      //   allowHeaderFiltering: false,
      //   cellTemplate: "status-cell"
      // },
      {
        dataField: "Label",
        caption: this.$t("common.label"),
        allowEditing: false,
        allowFiltering: true,
        allowHeaderFiltering: false,
        allowSorting: false,
        minWidth: "150",
        calculateCellValue: this.getLabels
      },
    ],
    smileysToShow: [
        ["sad", "happy"],
        ["sad", "poker", "happy"],
        ["sad", "poker", "semi-happy", "happy"],
        ["sad", "semi-sad", "poker", "semi-happy", "happy"],
        ["sad", "semi-sad", "poker", "semi-happy", "happy", "smile"],
        [
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
        ],
        [
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
        [
          "cry",
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
        [
          "frown",
          "cry",
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
      ]
  };
},

methods: {
  ...mapActions("users", [
    "getAll",
    "resetUsersData",
    "resetLoading",
    "fetchUserRoles",
    "inviteMultipleUsers",
    "setRfidMassActionUsersData",
    "fetchLabels",
    "fetchUsersGridData",
  ]),
  ...mapActions("modal", ["onResetModal", "setData"]),
  ...mapActions("grid", [
    "onTableHeader",
    "createTableHeaders",
    "updateTableHeaders",
    "resetTableHeaders",
    "resetFilterValues",
    "onSetFilterValue",
    "exportJobBE",
  ]),
  getCheckboxVal(data) {
    let parsedArray = data
    if(parsedArray && typeof parsedArray === "string")
      parsedArray = JSON.parse(parsedArray);
    if (Array.isArray(parsedArray)) {
      return parsedArray.join(' - ');
    } else {
      return '-';
    }
  },
  setSmileysColor(scaleCount) {
    let smileyColors = [];
    switch (scaleCount) {
      case 2:
        smileyColors = ["rgb(230, 10, 62)", "rgb(25, 179, 148)"];
        break;
      case 3:
        smileyColors = [
          "rgb(230, 10, 62)",
          "rgb(255, 152, 20)",
          "rgb(25, 179, 148)",
        ];
        break;
      case 4:
        smileyColors = [
          "rgb(230, 10, 62)",
          "rgb(246, 104, 34)",
          "rgb(178, 161, 62)",
          "rgb(25, 179, 148)",
        ];
        break;
      case 5:
        smileyColors = [
          "rgb(230, 10, 62)",
          "rgb(242, 81, 41)",
          "rgb(255, 152, 20)",
          "rgb(140, 165, 84)",
          "rgb(25, 179, 148)",
        ];
        break;
      case 6:
        smileyColors = [
          "rgb(230, 10, 62)",
          "rgb(240, 66, 45)",
          "rgb(250, 123, 28)",
          "rgb(209, 157, 45)",
          "rgb(117, 168, 96)",
          "rgb(25, 179, 148)",
        ];
        break;
      case 7:
        smileyColors = [
          "rgb(230, 10, 62)",
          "rgb(238, 57, 48)",
          "rgb(246, 104, 34)",
          "rgb(255, 152, 20)",
          "rgb(178, 161, 62)",
          "rgb(101, 170, 105)",
          "rgb(25, 179, 148)",
        ];
        break;
      case 8:
        smileyColors = [
          "rgb(230, 10, 62)",
          "rgb(237, 50, 50)",
          "rgb(244, 91, 38)",
          "rgb(251, 131, 26)",
          "rgb(222, 155, 38)",
          "rgb(156, 163, 74)",
          "rgb(90, 171, 111)",
          "rgb(25, 179, 148)",
        ];
        break;
      case 9:
        smileyColors = [
          "rgb(230, 10, 62)",
          "rgb(236, 45, 51)",
          "rgb(242, 81, 41)",
          "rgb(248, 116, 30)",
          "rgb(255, 152, 20)",
          "rgb(197, 158, 52)",
          "rgb(140, 165, 84)",
          "rgb(82, 172, 116)",
          "rgb(25, 179, 148)",
        ];
        break;
      case 10:
        smileyColors = [
          "rgb(230, 10, 62)",
          "rgb(235, 41, 52)",
          "rgb(241, 73, 43)",
          "rgb(246, 104, 34)",
          "rgb(252, 136, 24)",
          "rgb(229, 155, 34)",
          "rgb(178, 161, 62)",
          "rgb(127, 167, 91)",
          "rgb(76, 173, 119)",
          "rgb(25, 179, 148)",
        ];
        break;
    }

    return smileyColors;
  },
  setSmileysText(scaleCount) {
    let smileyText = [];
    switch (scaleCount) {
      case 3:
        smileyText = [
          "Poor",
          "OK",
          "Good",
        ];
        break;
      case 5:
        smileyText = [
          "Bad",
          "Poor",
          "OK",
          "Good",
          "Great",
        ];
        break;
    }
    return smileyText;
    },
  getData(data) {
    // console.log('getData', data.column.dataField);
    const customField = this.allCustomFields.find(field => field.id == data.column.dataField.split('.')[2]);
    const smileyColors = this.setSmileysColor(customField.metadata[0].scale_count);
    const smileyText = this.setSmileysText(customField.metadata[0].scale_count);
    // console.log('smileyColors', smileyColors);
    const visibleSmiley = this.smileysToShow[customField.metadata[0].scale_count - 2];
    // console.log('visibleSmiley', visibleSmiley);
    // console.log('smiley', smileyColors[+data.value - 1], visibleSmiley[+data.value - 1]);
    return {
      smileySvg: smileysJson[visibleSmiley[+data.value - 1] + 'Colored'],
      smileyColor: smileyColors[+data.value - 1],
      smileyText: smileyText[+data.value - 1]
    };
  },
  async massAction(action) {
    switch (action) {
      case "invite-to-dashboard":
        await this.inviteMultipleUsers(this.selectedUsersIds);
        break;
      case "revoke-from-dashboard":
        this.setData(this.selectedUsersIds);
        this.$bvModal.show("revoke-from-dashboard");
        break;
      case "user-type":
        this.setData(this.selectedUsersIds);
        this.$bvModal.show("change-user-type-massaction");
        break;
      case "rfid-enrollment": {
        this.rfidEnrollmentLoader = true;
        const { data } = await usersService.massactionRfidEnrollment({
          entityId: this.currentEntity.id,
          usersIds: this.selectedUsersIds,
        });

        //Checks if no available kiosk for all users
        let kiosksNotAvailable = data?.every(
          (user) => user.kiosk?.length == 0
        );
        let modalData = {};

        if (kiosksNotAvailable) {
          const usersNoEmailAndPhone = data.every(
            (user) => !user.email && !user.phone
          );
          const usersHaveEmailOrPhone = data.every(
            (user) => user.email || user.phone
          );
          //Case 1 : If all selected users have no email AND no phone
          if (usersNoEmailAndPhone) {
            modalData = {
              mainContent:
                "All selected users don’t have an email address or phone number and there are no kiosks available to print badges showing their Local QuickPass.",
              buttons: { continue: false, cancel: false, okay: true },
            };
          }
          //Case 2: If all selected users have email OR phone
          else if (usersHaveEmailOrPhone) {
            modalData = {
              mainContent:
                "You will not be able to print badges for the selected users because there are no kiosks available for printing but sending the RFID enrollment instructions is still available.",
              buttons: { continue: true, cancel: true, okay: false },
            };
          }
          //Case 3:If some of selectes users have email/phone and some don't
          else {
            //Filter users with no email and phone
            const usersWithoutEmailAndPhone = data.filter(
              (user) => !user.phone && !user.email
            );
            const formatterListOfUsersWithoutEmailAndPhone =
              usersWithoutEmailAndPhone
                ?.map((user) => {
                  return `(${user.userName} - ${user.user_type_name})`;
                })
                ?.join(", ");

            modalData = {
              mainContent:
                "The following users don’t have an email address or phone number and you will not be able to print badges for them because there are no kiosks available for printing: ",
              userListWithoutEmailAndPhone:
                formatterListOfUsersWithoutEmailAndPhone,
              extraContent:
                "Sending the RFID enrollment instructions is still available for other users.",
              buttons: { continue: true, cancel: true, okay: false },
            };
          }
          this.setData(Object.assign(modalData, { users: data }));
          this.rfidEnrollmentLoader = false;
          this.$bvModal.show("rfid-enrollment-confirmation-modal");
        } else {
          this.setRfidMassActionUsersData({
            users: data,
            kiosksNotAvailable: false,
          });
          this.$router.push({
            params: { rfidMassAction: true },
            name: "rfidEnrollmentMassAction",
          });
        }
        break;
      }
      case "permissions": {
        this.$bvModal.show("permissions");
        break;
      }
      case "add-label":
        this.setData(this.selectedUsersIds);
        this.$bvModal.show("add-label");
        break;
    }
  },
  getAccess(rowData) {
    if (
      +rowData.current_entity.is_revoked == 1 ||
      +rowData.current_entity.is_revoked == 2
    )
      return "No";
    if (+rowData.current_entity.is_revoked == 3) return "Pending";
    if (
      +rowData.current_entity.is_revoked == 0 &&
      rowData.current_entity.role_id
    )
      return rowData.current_entity.role.name;
    return "No";
  },
  getLabels(rowData) {
    const labelArr = [];
    rowData.labels.map(item => {
        const labelExist = this.allLabels.find(label => label.id == item.mapping_value);
        if (labelExist) labelArr.push(labelExist.name);
      });
      return labelArr.length ? labelArr.join(" - ") : "-"
  },
  getAction(action) {
    this.vaccineAction = action;
  },
  serverSideExport(e) {
    // console.log(e);
    // const columnNames = this.dataGrid.getVisibleColumns();
    // const columns = [];
    // for (let i = 0; i < columnNames.length; i++) {
    //   if (columnNames[i].allowExporting) {
    //     columns.push(columnNames[i].dataField);
    //   }
    // }
    this.exportJobBE({
      type: e.itemData,
      // headers: columns.reduce((accumulator, value) => {
      //   return { ...accumulator, [value]: value };
      // }, {}),
      gridName: "users",
      entity_id: this.currentEntity.id,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      active: 1,
      // filterBy: this.filterExportObject,
      // orderBy: this.sortExportObject,
    });
    this.dataGrid.endUpdate();
  },
  fetchTableHeaders() {
    this.onTableHeader({
      url: "/users-dxgrid-list",
      headers: usersColumns,
    });
  },
  contentReady(e) {
    let sortedExp = this.getSortedColumns();
    let filterExp = e.component.getCombinedFilter();
    if (filterExp || sortedExp) {
      this.showClearAll = true;
    } else {
      this.showClearAll = false;
    }
    this.setColumnChooserPosition();
    setTimeout(() => {
      this.gridLoaded = true;
    }, 5000);
  },
  getSortedColumns() {
    let allColumns = Array.from(
      Array(this.dataGrid.columnCount()).keys()
    ).map((index) => this.dataGrid.columnOption(index));
    allColumns = allColumns.find((col) => col.sortIndex != null);
    return allColumns;
  },
  setColumnChooserPosition() {
    var columnChooserView = this.dataGrid.getView("columnChooserView");
    if (!columnChooserView._popupContainer) {
      columnChooserView._initializePopupContainer();
      columnChooserView.render();
    }
    columnChooserView._popupContainer.option("position", {
      of: this.dataGrid.element(),
      my: this.getLanguage === 'en' ? "left top" : "right top",
      at: this.getLanguage === 'en' ? "left top" : "right top",
      offset: "0 50",
    });
  },
  async customLoad() {
    if (this.userEmail != "lt_techteam@visipoint.com") {
      await this.onTableHeader({
        url: "/users-dxgrid-list",
        headers: value,
        filters: "[]",
      });
      let value = JSON.parse(JSON.stringify(this.getTableHeaders));
      if (value) {
        value.pageIndex = 0;
        value.pageSize = 50;
        // value.columns.map((column)=>{
        //     if(column.name == "Status"){
        //         // console.log('column', column);
        //         if (!column.filterValues) {
        //             column.filterValues = [["Status", "contains", ['Active']]];
        //             column.filterType = "include";
        //         }
        //     }
        // });
        // const actionCol = value.columns.find(
        //   (column) => column.name == "Actions"
        // )
        // console.log('actionCol', value.columns, actionCol)
        if (value && value.columns) {
          for (let i = 0; i < value.columns.length; i++) {
            // if (
            //   value.columns[i].dataField == "label"
            // ) {
            //   value.columns[i].visibleIndex = 14;
            // }
            if (value.columns[i] && !value.columns[i+1]) { // make action column always at the end
              const actionColumn = value.columns.find(column => column.dataField == "actions");
              // console.log('actionColumn', actionColumn, value.columns);
              if (actionColumn)
                actionColumn.visibleIndex = value.columns[i].visibleIndex;
            }
          }
        }
      }
      // console.log("customLoad", value);
      return value;
    }
  },
  customSave(gridState) {
    if (this.userEmail != "lt_techteam@visipoint.com") {
      gridState.selectedRowKeys = [];
      let value = JSON.stringify(gridState);
      // console.log(this.getTableHeaders);
      if (!this.getTableHeaders) {
        this.createTableHeaders({
          url: "/users-dxgrid-list",
          headers: value,
          filters: "[]",
        });
      } else if (this.gridLoaded && value != JSON.stringify(this.getTableHeaders)) {
        console.log("else");
        this.updateTableHeaders({
          url: "/users-dxgrid-list",
          headers: value,
          filters: "[]",
        });
      }
      // console.log("customSave values", value, JSON.stringify(this.getTableHeaders));
    }
  },
  onEditorPreparing(e) {
    if (e.parentType == "filterRow") {
      e.editorOptions.placeholder = this.$t("common.grid.search");
    }
  },
  setUserData(data) {
    this.setData({
      type: "user_document",
      data,
    });
  },
  vaccineDocumentText(docmentVaccine, docmentPcr) {
    let docment = null;
    if (docmentVaccine) {
      docment = docmentVaccine;
    } else {
      docment = docmentPcr;
    }
    let vaccine = null;
    if (docment.status == "enabled") {
      if (docment.type == "covid_pcr") {
        vaccine =
          docment.metadata.certificateModel.tests &&
          docment.metadata.certificateModel.tests[0].testResult == "Detected"
            ? "Positive PCR"
            : "Negative PCR";
      }
      if (
        docment.type == "covid_vaccine" ||
        docment.type == "covid_recovery"
      ) {
        if (docment.is_expiry == 1) {
          vaccine = "Expired";
        } else {
          vaccine = "Vaccinated";
        }
      }
    } else {
      if (docment.status == "deleted") {
        vaccine = "Unchecked";
      } else {
        vaccine = docment.status;
      }
    }
    return vaccine;
  },
  // renderVaccineDocumentColor(type) {
  //     switch (type) {
  //     case 'Vaccinated':
  //         return 'text-primary font-weight-bold'
  //     case 'Unchecked':
  //         return 'text-secondary'
  //     case 'Expired':
  //         return 'text-warning font-weight-bold'
  //     case 'Negative PCR':
  //         return 'text-success font-weight-bold'
  //     default:
  //         return 'text-danger font-weight-bold';
  //     }
  // },
  openAddUserModal() {
    this.setData({});
    this.isAddModal = true;
  },
  filterOnUsersTypes() {
    return Object.keys(this.$route.params).length > 0
      ? this.onSetFilterValue({ UserType: this.$route.params.id })
      : this.onSetFilterValue({});
  },
  reset() {
    this.dataGrid.clearFilter("row");
    this.dataGrid.clearFilter("header");
    this.dataGrid.clearSorting();     
    this.showClearAll = false;
  },
  showColumnChooserPopup() {
    this.dataGrid.showColumnChooser();
  },
  refreshUsersGrid(data) {
    this.fetchLabels(this.currentEntity.id).then(data => {
      this.allLabels = data.data;
      this.dataGrid.refresh().then(() => {
        console.log("refreshed");
      });
    });

    // if (data && data.role_id) {
    //   console.log(data);
    //   this.$socket.emit("pingUpdateUserRole", {
    //     entity: this.currentEntity.id,
    //     user_id: data.id,
    //     role_id: data.role_id.id,
    //   });
    // }

    if (data && data == "resourceUpdated") {
      this.$bvModal.hide("permissions");
      this.dataGrid.deselectAll();
    }
    // this.$refs.archivedGridRef.refreshGrid()
  },
  resetGrid() {
    console.log("reset grid");
    this.fetchLabels(this.currentEntity.id).then((data) => {
      this.allLabels = data.data;
      this.dataGrid.refresh().then(() => {
        console.log("refreshed");
      });
    });
    this.dataGrid.deselectAll();
  },
  setUserStatus(userId) {
    if (userId) {
      this.dataGrid
        .getDataSource()
        .store()
        .push([
          {
            type: "update",
            key: userId,
            data: {
              VisiPointPassport: "Yes",
              Data: { current_entity: { passport_status: 2 } },
            },
          },
        ]);
    }
  },
  setUsersStatus(userIds) {
    userIds.map((userId) => {
      this.dataGrid
        .getDataSource()
        .store()
        .push([
          {
            type: "update",
            key: userId,
            data: {
              VisiPointPassport: "Yes",
              Data: { current_entity: { passport_status: 2 } },
            },
          },
        ]);
    });
  },
  async showEditUserModal(data) {
    this.cropImageData = null;
    await this.setData(this.addUserBackupDataModal);
    this.isHide = false;

    // await this.$bvModal.show("add-edit-user");
    if (data) {
      setTimeout(async () => {
        this.cropImageData = await data;
      }, 150);
    }
  },
  fetchBackupData(data) {
    this.addUserBackupDataModal = data;
    this.isHide = true;
  },
  onSelectionChanged(e) {
    this.selectedIds = e.selectedRowsData.map((row) => row.id);
    this.isFoundSelection = false;
    this.selectedUsersIds = [];

    let inviteToDashboard = true;
    let revokeFromDashboard = true;
    let rfidEnrollment = true;
    let isNormalUser = true;
    let isOwnerUser = false;
    let isloginUser = false;
    this.hasPermissionAction = true;
    this.isAddLabel = true;

    if (e.selectedRowKeys && e.selectedRowKeys.length) {
      this.selectedUsers = e.selectedRowsData;

      this.isFoundSelection = true;
      this.usersSelectedCounter = e.selectedRowKeys.length;
      this.selectedUsersIds = e.selectedRowsData.map((row) => {
        if (row.Data.isEntityOwner == "true") isOwnerUser = true;
        if (row.Data && row.Data.current_entity) {
          if (row.Data.current_entity.is_default_user) isNormalUser = false;
          if (row.Data.current_entity.user_id == this.userDetails.user_id)
            isloginUser = true;
          if (
            row.Data.current_entity.is_default_user ||
            row.Data.has_rfid == "false"
          )
            rfidEnrollment = false;

          if (row.Data.current_entity.system_user == 0)
            revokeFromDashboard = false;
          else inviteToDashboard = false;

          if (
            !isNormalUser ||
            isOwnerUser ||
            isloginUser ||
            +row.Data.current_entity.is_revoked == 1 ||
            +row.Data.current_entity.is_revoked == 2 ||
            (+row.Data.current_entity.is_revoked == 0 &&
              !row.Data.current_entity.role_id)
          )
            this.hasPermissionAction = false;
        }
        return row?.Data?.id;
      });

      if (
        !isNormalUser ||
        isOwnerUser ||
        isloginUser ||
        (!rfidEnrollment && !inviteToDashboard && !revokeFromDashboard)
      ) {

        if ((isOwnerUser || isloginUser) && rfidEnrollment) {
          this.isMassActionsAvailable = false;
          this.rfidEnrollment = true;
        } else {
          this.isMassActionsAvailable = true;
          this.rfidEnrollment = false;
        }
        this.isInviteToDashboard = false;
        this.isRevokeFromDashboard = false;
      } else {
        this.isMassActionsAvailable = false;
        this.rfidEnrollment = rfidEnrollment;
        this.isInviteToDashboard = inviteToDashboard;
        this.isRevokeFromDashboard = revokeFromDashboard;
      }

      if (!isNormalUser) this.isAddLabel = false;
      this.isDefaultUserSelected = !isNormalUser
  
    }
  },
  handleSelectAllValueChanged(e) {
    if (!e.value) {
      // Deselect filtered-out records

      const visibleRows = this.dataGrid.getVisibleRows();
      const visibleIds = visibleRows.map((row) => row.data.id);

      const deselectedIds = this.selectedIds.filter(
        (id) => !visibleIds.includes(id)
      );

      deselectedIds.forEach((id) => {
        this.dataGrid.deselectRows([id]);
      });

      this.selectedIds = visibleIds;
    }
  },
  showCurrentTab(value) {
    this.activeUsersTab = false;
    this.archivedUsersTab = false;
    if (value == "active") {
      this.activeUsersTab = true;
    } else if (value == "archive") {
      this.archivedUsersTab = true;
    }
  },
  onDataErrorOccurred(e){
    console.log('onDataErrorOccurred e', e);
    setTimeout(() => {  
      let errorRow = document.querySelector(".dx-datagrid-headers .dx-error-message");  
      errorRow.innerHTML = this.$t('common.notes.anErrorOccurredGrid');  
    },100);
  },
  async renderUsersGridData(){
    this.dataStore = await new CustomStore({
      key: "UniqueId",
      load: (loadOptions) => {
        console.log("load fn from custom store fired");
        this.gridEmptyMessage = this.$t('common.grid.loadingData');
        let params = "?";
        let filterQuery = "";
        console.log("filterQuery", filterQuery);
        let sortObject = { sortField: null, sortOrder: "" };
        [
          "skip",
          "take",
          "requireTotalCount",
          "requireGroupCount",
          "sort",
          "filter",
          "totalSummary",
          "group",
          "groupSummary",
        ].forEach((i) => {
          console.log("forEach", i, loadOptions[i]);
          console.log("isnotempty", isNotEmpty(loadOptions[i]));
          if (i in loadOptions && isNotEmpty(loadOptions[i])) {
            params += `${i}=${JSON.stringify(loadOptions[i])}&`;
            if (i == "filter") {
              console.log("loadOptions[i]", loadOptions[i]);
              filterQuery += `${JSON.stringify(loadOptions[i])}`;
            }
            if (i == "sort") {
              sortObject.sortField = loadOptions[i][0].selector;
              sortObject.sortOrder = loadOptions[i][0].desc ? "desc" : "asc";
            }
          }
        });
        // this.resetUsersData();
        console.log("1 params", params);
        params = params.slice(0, -1);
        console.log("2 params", params);
        let filters;
        let finalFilterObject = {};
        this.multipleFilters = [];
        if (filterQuery) filters = JSON.parse(filterQuery);
        if (filters) console.log("filters", filters);
        if (filters && typeof filters[0] === "string") {
          if (filters[0] == "!") {
            console.log("not");
            if (typeof filters[1] === "object") {
              const excludeIds = [];
              const columnHeader =
                typeof filters[1][0] === "object"
                  ? filters[1][0][0] + "HeaderFilter"
                  : filters[1][0] + "HeaderFilter";
              const columnHeaderFilter =
                columnHeader.charAt(0).toLowerCase() + columnHeader.slice(1);
              console.log(columnHeaderFilter); // name of column filter
              if (typeof filters[1][0] === "object") {
                console.log("obj");
                filters[1].map((item) => {
                  if (typeof item === "object") {
                    console.log("item", item[2][0]);
                    excludeIds.push(item[2][0]);
                  }
                });
              } else {
                console.log("else");
                // filters[1].map(item => {
                // if (typeof item === "object") {
                console.log("item", filters[1][2]);
                excludeIds.push(filters[1][2]);
                // }
                // });
              }
              console.log(this[columnHeaderFilter]);
              const arr = this[columnHeaderFilter].filter(
                (el) => !excludeIds.includes(el.value[2])
              );
              console.log("arr", arr, excludeIds);
              if (typeof filters[1][0] === "object") {
                finalFilterObject[filters[1][0][0]] = arr.map((item) => {
                  return item.value[2];
                });
              } else {
                finalFilterObject[filters[1][0]] = arr.map((item) => {
                  return item.value[2];
                });
              }
              console.log("finalFilterObject", finalFilterObject);
              // if (this.multipleFilters.length > 0) {
              this.multipleFilters.push(finalFilterObject);
              // }
            }
          } else {
            if((filters[1] === "contains" || filters[1] === "=") && this.allFilterHeaders.includes(filters[0])) filters[2] = [filters[2]]; // make it array;
            finalFilterObject[filters[0]] =
              filters[1] === "contains" || filters[1] === "="
                ? filters[2]
                : filters[2];
          }

          // if (this.multipleFilters.length > 0) {
          this.multipleFilters.push(finalFilterObject);
          // }
        } else {
          // const isOr = filters[1] === 'or';
          // const isAnd = filters[1] === 'and';
          if (filters)
            for (const filter of filters) {
              if (filter[0] == "!") {
                // console.log('multiple filters not');
                if (typeof filter[1] === "object") {
                  const excludeIds = [];
                  const columnHeader =
                    typeof filter[1][0] === "object"
                      ? filter[1][0][0] + "HeaderFilter"
                      : filter[1][0] + "HeaderFilter";
                  const columnHeaderFilter =
                    columnHeader.charAt(0).toLowerCase() +
                    columnHeader.slice(1);
                  console.log(columnHeaderFilter); // name of column filter
                  if (typeof filter[1][0] === "object") {
                    // console.log('obj');
                    filter[1].map((item) => {
                      if (typeof item === "object") {
                        // console.log('item', item[2][0]);
                        excludeIds.push(item[2][0]);
                      }
                    });
                  } else {
                    // console.log('else');
                    // filters[1].map(item => {
                    // if (typeof item === "object") {
                    // console.log('item', filter[1][2]);
                    excludeIds.push(filter[1][2]);
                    // }
                    // });
                  }
                  // console.log(this[columnHeaderFilter]);
                  const arr = this[columnHeaderFilter].filter(
                    (el) => !excludeIds.includes(el.value[2])
                  );
                  // console.log('arr', arr, excludeIds);
                  if (typeof filter[1][0] === "object") {
                    finalFilterObject[filter[1][0][0]] = arr.map((item) => {
                      return item.value[2];
                    });
                  } else {
                    finalFilterObject[filter[1][0]] = arr.map((item) => {
                      return item.value[2];
                    });
                  }
                  console.log("finalFilterObject", finalFilterObject);
                  this.multipleFilters.push(finalFilterObject);
                }
              }
              let orExist;
              let andExist;
              if (typeof filter === "object") {
                console.log("obj", filter);
                orExist = filter.find((item) => item === "or");
                andExist = filter.find((item) => item === "and");
                if (filter[1] == "or") {
                  // Header Filter - Gather In One Condition
                  if (
                    filter[0][1] === ">=" ||
                    filter[0][1] === "<=" ||
                    filter[0][1] === "<"
                  ) {
                    const finalFilter = {};
                    const condition = [];
                    for (const filterItem of filter) {
                      if (filterItem[2]) condition.push(filterItem[2][0]);
                    }
                    finalFilter[filter[0][0]] = {
                      start: condition[0].replace(/\//g, "-"),
                      end: condition[1].replace(/\//g, "-"),
                    };
                    this.multipleFilters.push(finalFilter);
                  } else {
                    // Gather In One Condition
                    for (const filter of filter) {
                      if (filter[1] === "contains" || filter[1] === "=") {
                        if (this.allFilterHeaders.includes(filter[0])) filter[2] = [filter[2]]; // make it array;
                        const finalFilter = {};
                        finalFilter[filter[0]] =
                          filter[1] === "contains" || filter[1] === "="
                            ? filter[2]
                            : filter[2];

                        // Header Filter - Gather In One Condition
                        const filterExist = this.multipleFilters.find(
                          (item) => item[filter[0]]
                        );
                        if (!filterExist)
                          this.multipleFilters.push(finalFilter);
                        else filterExist[filter[0]].push(filter[2][0]);
                      }
                    }
                  }
                } // -------------- Header Filter --------------------
              }
              if (
                filter.length > 0 &&
                filter[0] &&
                filter[0] !== "Actions" &&
                !orExist &&
                !andExist
              ) {
                if (filter[1] === "contains" || filter[1] === "=") {
                  if (this.allFilterHeaders.includes(filter[0])) filter[2] = [filter[2]]; // make it array;
                  const finalFilter = {};
                  finalFilter[filter[0]] =
                    filter[1] === "contains" || filter[1] === "="
                      ? filter[2]
                      : filter[2];

                  // Header Filter - Gather In One Condition
                  const filterExist = this.multipleFilters.find(
                    (item) => item[filter[0]]
                  );
                  if (!filterExist) this.multipleFilters.push(finalFilter);
                  else filterExist[filter[0]].push(filter[2][0]);
                }
              } else if (andExist) {
                for (const andFilter of filter) {
                  if (
                    andFilter.length > 0 &&
                    andFilter[0] &&
                    andFilter[0] !== "Actions"
                  ) {
                    if (andFilter[1] === "contains" || andFilter[1] === "=") {
                      if (this.allFilterHeaders.includes(andFilter[0])) andFilter[2] = [andFilter[2]]; // make it array;
                      const finalFilter = {};
                      finalFilter[andFilter[0]] =
                        andFilter[1] === "contains" || andFilter[1] === "="
                          ? andFilter[2]
                          : andFilter[2];
                      this.multipleFilters.push(finalFilter);
                    }
                  }
                }
              }
            }
        }

        finalFilterObject =
          this.multipleFilters && this.multipleFilters.length > 0
            ? Object.assign({}, ...this.multipleFilters)
            : finalFilterObject;

        // Extract entries and filter only those with keys starting with "Data.customFields."
        const customFieldsEntries = Object.entries(finalFilterObject).filter(([key]) =>
          key.startsWith('Data.customFields.')
        );

        // Map the filtered entries to the new structure
        const customFieldsArray = customFieldsEntries.map(([key, value]) => {
          const customFieldId = key.split('.')[2]; // Extract the customFieldId part
          return {
            customFieldId,
            value,
          };
        });

        // Return the new structure
        const customFieldsFilter = {
          customFields: customFieldsArray,
        };

        // Remove the extracted keys from the original filterBy object
        // customFieldsEntries.forEach(([key, value]) => {
        //   delete finalFilterObject[key];
        // });

        this.filterExportObject = finalFilterObject;
        this.sortExportObject = sortObject;

        console.log(
          "fffff",
          finalFilterObject,
          JSON.stringify(finalFilterObject)
        );

        for (var prop in finalFilterObject) {
          if (typeof finalFilterObject[prop] === "string") {
            finalFilterObject[prop] = finalFilterObject[prop].trim();
          }
        }
        let queryParams = {
          filterBy: finalFilterObject,
          customFieldsFilter,
          orderBy: sortObject ? sortObject : { sortField: null },
        };

        if (this.isExport) {
          queryParams.isExporting = true;
        }

        Object.assign(queryParams.filterBy, { Status: ["Active"] });
        return Api()
          .get(
            `/users/${store.getters["authfack/currentEntity"].id}${params}`,
            {
              params: queryParams,
            }
          )
          .then(async(data) => {
            const dataArr = [];
            await data.data.users.map((user) => {
              let passportStatus = "-";
              let entity = this.currentEntity;
              let imageProfile = user.current_entity.image;
              if (imageProfile !== null) {
                imageProfile = imageProfile.replace("entity_id", entity.id);
              }

              if (user.user_passport && user.user_passport.is_active == 0) {
                passportStatus = "Deactivated";
              } else if (user.user_passport == null) {
                passportStatus = "No";
              } else if (
                user.user_passport &&
                user.user_passport.is_active == 1
              ) {
                passportStatus = "Yes";
              }

              dataArr.push({
                Image: imageProfile ,
                FirstName:
                  user.first_name && user.first_name.length
                    ? user.first_name
                    : "-",
                LastName:
                  user.last_name && user.last_name.length
                    ? user.last_name
                    : "-",
                UserType:
                  user.current_entity && user.current_entity.user_type
                    ? user.current_entity.user_type.name
                    : "-",
                ID: user.user_id && user.user_id.length ? user.user_id : "-",
                EmailAddress: user.email && user.email.length ? user.email : "-",
                DashboardAccess: user.system_user == 0 ? "No" : "Yes",
                Status: user.is_active == 1 ? "Active" : "Deactivated",
                vaccine_document:
                  user.id == entity.id
                    ? ""
                    : user.last_document_vaccine || user.last_document_pcr
                    ? this.vaccineDocumentText(
                        user.last_document_vaccine,
                        user.last_document_pcr
                      )
                    : "Unchecked",
                RFID: user.rf_ids?.length ? user.rf_ids : null,
                PhoneNumber: user.phone ? user.phone : "-",
                VisiPointPassport: passportStatus,
                Data: user,
                UniqueId: user.id,
                FullName:
                  user.fullName && user.fullName.length ? user.fullName : "-",
                LastVaccine: user.last_document_vaccine
                  ? user.last_document_vaccine
                  : user.last_document_pcr,
                is_default_user: !!user.is_default_user,
                // VehicleRegistration: user.vehicle_registration
                //  ? user.vehicle_registration
                //  : "-",
                // CompanyName: user.company_name ? user.company_name : "-",
                current_entity: user.current_entity,
                labels: user.labels,
              });
            });
            this.gridEmptyMessage = await   this.$t('common.grid.noRecordsYet');
            
            // this.isServerSideExport = data.data.totalCount >= process.env.VUE_APP_EXPORT_LIST_COUNT;
            this.finalFilterObject = finalFilterObject;
            this.sortObject = sortObject ? sortObject : { sortField: null };
            this.totalCount = data.data.totalCount;

            await this.dataGrid.endCustomLoading();
            return {
              data: dataArr,
              totalCount: data.data.totalCount,
              summary: data.data.summary,
              groupCount: data.data.length,
            };
            
          })
          .catch((err) => {
            throw new Error(err);
          });
      },
      // eslint-disable-next-line no-unused-vars
    })
  }
},
watch: {
  getTableHeaders(value) {
    console.log("watch", value);
  },
  getExportProgessAppearance(value) {
    value && this.$bvModal.show("exportingProgress");
  },
  getInvitationChanged(value) {
    return value && this.refreshUsersGrid();
  },
},
computed: {
  ...mapGetters("i18N",["getLanguage"]),
  ...mapGetters("users", ["getInvitationChanged"]),
  ...mapGetters("grid", [
    "getTableHeaders",
    "getExportProgessAppearance",
  ]),
  ...mapGetters("authfack", ["currentEntity", "userDetails"]),
  ...mapGetters("emergency", ["getActiveSessionsCount"]),
  dataGrid() {
    return this.$refs[this.dataGridRefName].instance;
  },
  userEmail() {
    return this.userDetails && this.userDetails.email;
  },
  getUsersURL() {
    return Object.keys(this.$route.params).length > 0
      ? this.$route.fullPath
      : "/users";
  },
  gridColumns() {
    const fields = this.fields.map(field => {
      let column = {
        dataField: field.dataField,
        caption: field.caption,
        minWidth: field.minWidth,
        allowFiltering: field.allowFiltering,
        allowEditing: field.allowEditing,
        showInColumnChooser: field.showInColumnChooser,
        alignment: field.alignment,
        cssClass: field.cssClass,
        allowExporting: field.allowExporting,
        visible: this.getTableHeaders &&
            this.getTableHeaders.columns?.find(item => item.dataField == field.dataField) &&
            (this.getTableHeaders.columns?.find(item => item.dataField == field.dataField).visible ||
            this.getTableHeaders.columns?.find(item => item.dataField == field.dataField).visible == false) ?
            this.getTableHeaders.columns?.find(item => item.dataField == field.dataField).visible : (field.dataField == "ID" ? false : true),
        filterValue: this.getTableHeaders && this.getTableHeaders.columns?.find(item => item.dataField == field.dataField) && this.getTableHeaders.columns?.find(item => item.dataField == field.dataField).filterValue,
        filterValues: this.getTableHeaders && this.getTableHeaders.columns?.find(item => item.dataField == field.dataField) && this.getTableHeaders.columns?.find(item => item.dataField == field.dataField).filterValues,
        visibleIndex: this.getTableHeaders && this.getTableHeaders.columns?.find(item => item.dataField == field.dataField) && this.getTableHeaders.columns?.find(item => item.dataField == field.dataField).visibleIndex,
        sortOrder: this.getTableHeaders && this.getTableHeaders.columns?.find(item => item.dataField == field.dataField) && this.getTableHeaders.columns?.find(item => item.dataField == field.dataField).sortOrder,
        sortIndex: this.getTableHeaders && this.getTableHeaders.columns?.find(item => item.dataField == field.dataField) && this.getTableHeaders.columns?.find(item => item.dataField == field.dataField).sortIndex,
        allowHeaderFiltering: field.allowHeaderFiltering,
        filterOperations: this.allowedOperations,
        allowSorting: field.allowSorting,
        calculateCellValue: field.calculateCellValue
      };
      
      if (field.cellTemplate) {
        column.cellTemplate = field.cellTemplate;
      }
      
      if (field.headerFilterDataSource) {
        column.headerFilter = {
          dataSource: this[field.headerFilterDataSource]
        };
      }
      
      return column;
    });
      this.allCustomFields.forEach(field => {
        let obj = {
          dataField: `Data.customFields.${field.id}`,
          caption: field.type == "ratingScale" && (field.metadata[0].show_as == "stars" || field.metadata[0].show_as == "labels") ? `${field.name} (Out of ${field.metadata[0].scale_count})` : field.name,
          allowFiltering: !field.type == "ratingScale" || (field.type == "ratingScale" && (field.metadata[0].show_as == "stars" || field.metadata[0].show_as == "labels")),
          showInColumnChooser: true,
          allowExporting: false,
          allowHeaderFiltering: field.type == "ratingScale" || field.type == "toggleButton",
          filterOperations: this.allowedOperations,
          allowSorting: false,
          alignment: "start",
          width: "230",
          visible: this.getTableHeaders &&
            this.getTableHeaders.columns?.find(item => item.dataField == `Data.customFields.${field.id}`) &&
            (this.getTableHeaders.columns?.find(item => item.dataField == `Data.customFields.${field.id}`).visible ||
            this.getTableHeaders.columns?.find(item => item.dataField == `Data.customFields.${field.id}`).visible == false) ?
            this.getTableHeaders.columns?.find(item => item.dataField == `Data.customFields.${field.id}`).visible : true,
          filterValue: this.getTableHeaders &&
            this.getTableHeaders.columns?.find(item => item.dataField == `Data.customFields.${field.id}`) &&
            this.getTableHeaders.columns?.find(item => item.dataField == `Data.customFields.${field.id}`).filterValue,
            filterValues: this.getTableHeaders &&
            this.getTableHeaders.columns?.find(item => item.dataField == `Data.customFields.${field.id}`) &&
            this.getTableHeaders.columns?.find(item => item.dataField == `Data.customFields.${field.id}`).filterValues,
            visibleIndex: this.getTableHeaders &&
            this.getTableHeaders.columns?.find(item => item.dataField == `Data.customFields.${field.id}`) &&
            this.getTableHeaders.columns?.find(item => item.dataField == `Data.customFields.${field.id}`).visibleIndex,
            sortOrder: this.getTableHeaders &&
            this.getTableHeaders.columns?.find(item => item.dataField == `Data.customFields.${field.id}`) &&
            this.getTableHeaders.columns?.find(item => item.dataField == `Data.customFields.${field.id}`).sortOrder,
            sortIndex: this.getTableHeaders &&
            this.getTableHeaders.columns?.find(item => item.dataField == `Data.customFields.${field.id}`) &&
            this.getTableHeaders.columns?.find(item => item.dataField == `Data.customFields.${field.id}`).sortIndex,
        };
        if (field.type === "date") obj.cellTemplate = "date-template";
        else if (field.type === "toggleButton") {
          obj.cellTemplate = "toggle-template";
          obj.headerFilter = {
            dataSource: this.toggleHeaderFilter
          };
        } else if (field.type === "ratingScale") {
          let ratingHeaderFilter = [];
          if (field.metadata[0].show_as !== "smileys") {
            for (let i = 0; i < field.metadata[0].scale_count; i++) {
              ratingHeaderFilter.push({
                text: (i+1).toString(),
                value: (i+1).toString()
              });
            }
          } else {
            ratingHeaderFilter = [
              { text: "Bad", value: 1 },
              { text: "Poor", value: 2 },
              { text: "OK", value: 3 },
              { text: "Good", value: 4 },
              { text: "Great", value: 5 },
            ]
          }
          obj.headerFilter = {
            dataSource: ratingHeaderFilter
          };
          obj.cellTemplate = `${field.metadata[0].show_as}-template`;
          obj.cssClass = field.metadata[0].show_as + field.metadata[0].scale_count;
        } else if (field.type == "checkboxes") {
          obj.cellTemplate = "checkboxes-template";
        } else obj.cellTemplate = "customField-template";
        fields.push(obj);
      });
      fields.push({
        dataField: "actions",
        caption: this.$t("common.grid.actions"),
        minWidth: 350,
        allowFiltering: false,
        allowExporting: false,
        allowEditing: false,
        cssClass: "select-actions select-actionsDAsh",
        cellTemplate: "actions-cell"
      });
      // console.log('fields', fields);
      return fields;
  },
},
mounted() {
  this.dataGrid.beginCustomLoading();
  window.addEventListener("unload", this.resetFilterValues());
  this.fetchTableHeaders();
  this.filterOnUsersTypes();
  this.userParams.id && this.onSetFilterValue({ id: this.userParams.id });
},

async beforeMount() {
  if(this.getLanguage == 'ar') {
    this.rtlEnabled = true;
  }
  const res = await this.fetchUsersGridData();
  this.usersGridData = res.data;
  this.allCustomFields = await this.usersGridData.customFields;
  this.allCustomFields.forEach(field => {
    if (field.type == "ratingScale" || field.type == "toggleButton") {
      this.allFilterHeaders.push(`Data.customFields.${field.id}`);
    }
  });
  
  // this.userTypeHeaderFilter = await this.usersGridData.userTypesOneLevel;
  await this.usersGridData.userTypesOneLevel.map((userType) => {
    this.userTypeHeaderFilter.push({
      text: userType.name,
      value: userType.id,
    });
  });
  this.allLabels = await this.usersGridData.labels;
  this.documentsTypesAraa = await this.usersGridData.documentTypes?.documents;  
  this.vaccinePCRColumnAppearance = this.usersGridData.dashboardColumns;
  for (let i = 0; i < this.usersGridData.roles.length; i++) {
    this.systemUserHeaderFilter.push({
      text: this.usersGridData.roles[i].name,
      value: ["DashboardAccess", "contains", this.usersGridData.roles[i].id],
    });
  }

  await this.resetLoading();
  await this.renderUsersGridData();
},
destroyed() {
  this.resetTableHeaders();
  this.resetFilterValues();
  this.onResetModal();
  this.resetUsersData();
},
created() {
  document.addEventListener("mousedown", (e) => {
    if (e.path) {
      let isColumnChooser = false;
      for (let i = 0; i < e.path.length; i++) {
        if (typeof e.path[i].matches == "function") {
          if (e.path[i].matches(".dx-overlay-content")) {
            isColumnChooser = true;
          }
        }
      }
      if (!isColumnChooser) this.dataGrid.hideColumnChooser();
    }
  });
},
sockets: {
  updateUserType(data) {
    console.log("updateUserType", data);
    this.hideLoader = true;
    this.dataGrid.refresh().then(() => {
      console.log("refreshed");
      setTimeout(() => {
        this.hideLoader = false;
      }, 500);
    });
  },
},
};
</script>

<style lang="scss" scoped>
.rating-star {
  position: absolute;
  top: 15%;
  margin: auto;
  color: white;
  font-size: 10px;
}
.rating-label-container {
  background-color: #103f5e;
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.rating-label {
  position: absolute;
  top: 12%;
  margin: auto;
  color: white;
  font-size: 10px;
}
button.btn.d-flex.align-items-center.justify-content-center.text-center.session-btn.btn-primary.btn-sm.rounded-pill {
height: 27px;
width: 127px;
 
 
font-weight: 400;
font-size: 14px;
line-height: 19px;
text-align: center;
color: #ffffff;
}

p {
font-size: 12px;
color: #b9b7b7;
}

img {
height: 27px;
width: 27px;
}

.hide-loader .dx-overlay-content.dx-resizable.dx-loadpanel-content {
display: none !important;
}
.users-list-table {
tbody {
  color: #495057;
}
}

.white-bg-secc {
background-color: white;
padding-inline-start: 0px;
padding-top: 35px;
border-radius: 8px !important;
}

.in-color {
color: #34c38f;
}
.out-color {
color: #f46a6a;
}

.main-grid-buttons {
// padding-top: 38px;
margin-bottom: 1px;
.grid-buttons {
  width: auto;
  // height: 76px;
  background: #ffffff;
  padding: 32px 0;
  border-radius: 8px 8px 0px 0px;
  display: flex;
  align-items: end;
  .grid-buttons-contanier {
    padding-inline-start: 24px;
    button.active-users-view,
    button.archived-users-view {
      width: 125px;
      height: 27px;
      background: #103f5e;
      border-radius: 13.5px;
      border: none;
       
       
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      color: #ffffff;
    }
    button.active-users-view {
      margin-inline-end: 24px;
    }
    // button.archived-users-view{
    //     &:disabled{
    //         background: #C7C7C7;
    //     }
    // }
  }
}

.seperator-main-grid-buttons {
  height: 1px !important;
  margin: 0 24px;
  background: #000000;
  opacity: 0.08;
}
}
</style>
  
<style lang="scss">
.usersGridHeight .dx-datagrid {
  height: calc(100vh - 290px);
  .dx-freespace-row {
    display: none;
  }
}
.usersGridHeightWithAlert .dx-datagrid {
  height: calc(100vh - 336px);
  .dx-freespace-row {
    display: none;
  }
}
#add-edit-user-hide___BV_modal_content_ {
  display: none;
}
.grid-smiley-container {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline-start: 0.2px;
  svg {
    width: 100%;
    height: 100%;
  }
  // span svg path{
  //   fill: #ffffff;
  // }
  // span svg path:first-of-type {
  //   stroke: #ffffff;
  // }
  // .svg-div svg {
  //   width: 21px;
  //   height: 24px;
  // }
}
div#revoke-from-dashboard___BV_modal_content_ {
background: #ffffff;
border-radius: 26px;
width: 579px;
margin-top: 150px;
div#revoke-from-dashboard___BV_modal_body_ {
  .massaction-confirm-modal .confirm-modal-body {
    width: 469px !important;
    line-height: 188% !important;
  }
  .massaction-confirm-modal .confirm-modal-body:lang(ar) {
    width: fit-content !important;
    line-height: 188% !important;
  }
}
}
div#activeUsersListGridContainer {
.dx-datagrid-header-panel {
  border-top: none !important; // overlaps with buttons separator
}
.smiley-text {
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 19px !important;
  margin: auto 0 !important;
}
ul.dropdown-menu.show {
  align-items: center !important;
  background: #ffffff !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 6px !important;
  text-align: center !important;
  max-width: 195px !important;
  max-height: 179px !important;
  margin-top: 6px !important;
  overflow-y: scroll;
}
button.dropdown-item {
  margin: auto !important;
   
   
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 19px !important;
  text-align: center !important;
  color: #787878 !important;
  padding-inline-end: 22px !important;
}
.dropdown-menu.show::-webkit-scrollbar {
  width: 9px;
}
.dropdown-menu.show::-webkit-scrollbar-track {
  background: #ededed;
  height: 129px;
  border-radius: 8.5px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.dropdown-menu.show::-webkit-scrollbar-thumb {
  background: #666666;
  border-radius: 8.5px;
  height: 82px;
}

// .dx-datagrid {
//   padding-bottom: 55px !important;
// }
.dx-datagrid-rowsview .dx-row {
   
   
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;

  color: #495057;
}
.dx-datagrid-headers .dx-datagrid-table .dx-row > td {
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 17px !important;
  color: #939393 !important;
}

.dx-toolbar .dx-toolbar-before {
  padding-inline-end: 15px;
  display: flex;
  align-items: center;
}
.d-flex.justify-content-between.dx-template-wrapper.dx-item-content.dx-toolbar-item-content{
align-items: center;
}
.toolbar-primary {
  background-color: #2680eb;
}
.toolbar-success {
  background-color: #34c38f;
}
.toolbar-alert {
  background-color: #f46a6a;
}
.toolbar-main {
  background-color: #103f5e;
  height: 27px;
  max-height: 27px;
}
.toolbar-secondary {
  background-color: #2680eb;
  height: 27px;
  max-height: 27px;
}
.v-line {
  width: 1px;
  height: 27px;
  /* margin: 0 16px; */
  margin-top: 0px;
  margin-inline-end: 8px;
  margin-bottom: 0px;
  margin-inline-start: 24px;
  opacity: 1!important; 
  background-color: #EBEBEB;
}
.dx-datagrid-rowsview .dx-selection > td .dx-link {
  color: #a5a5a5;
}
.dx-datagrid-rowsview .dx-selection.dx-row:hover > td .dx-link {
  color: #a5a5a5;
}
.resend-compliance-btn {
  border: none;
  background-color: #ffffff;
  padding: 0;
  margin-top: 0.5px;
  margin-inline-end: 0;
  margin-bottom: 0;
  margin-inline-start: 9px;
}
.resend-compliance-btn:disabled {
  opacity: 0.5;
  color: #a5a5a5;
}

.dx-row.dx-selection:has(.dx-checkbox.dx-state-disabled) {
  background-color: #efefef !important;
}
.dx-link.dx-link-edit.dx-state-disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.38;
}
}

h5.modal-title {
width: 100%;
text-align: center;
font-size: 19px;
font-weight: 700;
}

.add-user-icon {
font-size: 1.5rem;
color: #103f5e;
transition: 0.3s;
cursor: pointer;
&:hover {
  color: #34c38f;
}
}
//     .seprator-line{
//         height:5px;
//         width:100px;
// background: red;
//     }
.users-white-bg-sec {
background-color: white;
padding-inline-start: 0px;
// padding-top: 38px;
border-radius: 8px !important;
}

.toolbar-mass-actions-note {
margin-inline-start: 28px;
font-weight: 400 !important;
font-size: 14px !important;
line-height: 17px !important;
color: rgba(147, 147, 147, 0.87);
}

button.btn.d-flex.align-items-center.justify-content-center.text-center.top-users-btn.btn-primary.btn-sm.rounded-pill {
height: 27px;
width: 127px;
 
 
font-weight: 400;
font-size: 16px;
line-height: 19px;
text-align: center;
color: #ffffff;
}

[aria-label="Column RFID"] {
.dx-sort.dx-sort-up,
.dx-sort.dx-sort-down {
  display: none !important;
}
}
.diabledBtnTab {
background: #AFAFAF !important;
}

[aria-label="Column Document - Vaccine/PCR"],
[aria-label="Column Dashboard Access"] {
.dx-sort.dx-sort-up,
.dx-sort.dx-sort-down {
  display: none !important;
}
}
</style>